import { lazy } from "react";
import Loadable from "../../../layout/fullLayout/loadable/loadable";
import { AuthorizedRoute } from "../../../router/AuthorizedRoute";
import { MODULE_IDS } from "../../../constants/enums";
import { APP_FILE_BEFORE_PROFILE, APP_FILE_MANAGE_USER, APP_FILE_MY_PROFILE_VIEW } from "./Users.constants";

const BeforeProfile = Loadable(
  lazy(() =>
    import("./UsersList").then(
      ({ BeforeProfile }) => ({
        default: BeforeProfile,
      })
    )
  )
);

const ManageUserWrapper = Loadable(
  lazy(() =>
    import("./ManageUserWrapper").then(({ ManageUserWrapper }) => ({
      default: ManageUserWrapper,
    }))
  )
);
const MyProfileView = Loadable(
  lazy(() =>
    import("./MyProfileView").then(
      ({ MyProfileView }) => ({
        default: MyProfileView,
      })
    )
  )
);

export const UsersRoutes = [
   {
        path: `${APP_FILE_BEFORE_PROFILE}`,
        exact: true,
        element: (
          <AuthorizedRoute moduleKeys={[MODULE_IDS.USERS]}>
            <BeforeProfile />
          </AuthorizedRoute>
        ),
      },
      {
        path: `${APP_FILE_MANAGE_USER}`,
        exact: true,
        element: (
          <AuthorizedRoute moduleKeys={[MODULE_IDS.USERS]}>
            <ManageUserWrapper />
          </AuthorizedRoute>
        ),
      },
      {
        path: `${APP_FILE_MANAGE_USER}/:userId`,
        exact: true,
        element: (
          <AuthorizedRoute moduleKeys={[MODULE_IDS.USERS]}>
            <ManageUserWrapper />
          </AuthorizedRoute>
        ),
      },
       {
              path: `${APP_FILE_MY_PROFILE_VIEW}`,
              exact: true,
              element: (
                <AuthorizedRoute moduleKeys={[]} allowFullAccess>
                  <MyProfileView />
                </AuthorizedRoute>
              ),
            },
];
